import { Col, Divider, Row } from 'antd';
import { FormCheckBox } from 'presentation/components/form/FormCheckBox.component';
import React from 'react';
import { DATE_FORMAT } from 'utilities/constants/DATE';
import { commonHelpers } from 'utilities/helpers';
import { ItemView } from '../../CU-015-02/components/ItemView';
import { ContractInfoPtops, StepProps } from '../props/StepProps';

export const DataView = ({ data }: StepProps) => {
    const [displayInfo, setDisplayInfo] = React.useState<ContractInfoPtops>();

    React.useEffect(() => {
        if (data) {
            const newDisplayInfo: ContractInfoPtops = { ...data };

            setDisplayInfo(data);
            if (data?.penaltyRate) {
                newDisplayInfo.penaltyRateDisplay = `売却価格の${commonHelpers.formatMoney(data?.penaltyRate)}%相当額以上`;
            }

            setDisplayInfo(newDisplayInfo);
        }
    }, [data]);

    return (
        <>
            <Row className="min-w-min mb-6">
                <div className="w-full mb-[48px]">
                    <span className="content-step-form heading-step-form">基本情報</span>
                    <Divider className="mb-6 my-1" />
                    <Row gutter={[0, 12]} className="mb-6">
                        <Col span={12} className="pr-[12px]">
                            <ItemView
                                label="委任者"
                                value={displayInfo?.memberName}
                                formatNumber={false}
                                labelClassName="content-step-form label-step-form"
                            />
                        </Col>
                        <Col span={12} className="pl-[12px]">
                            <ItemView
                                label="委任者住所"
                                value={displayInfo?.address}
                                labelClassName="content-step-form label-step-form"
                            />
                        </Col>
                    </Row>
                    <Row gutter={[0, 12]} className="mb-6">
                        <Col span={12} className="pr-[12px]">
                            <ItemView
                                label="受任者"
                                value={displayInfo?.nameAdmin}
                                formatNumber={false}
                                labelClassName="content-step-form label-step-form"
                            />
                        </Col>
                        <Col span={12} className="pl-[12px]">
                            <ItemView
                                label="受任者住所"
                                value={displayInfo?.trusteeAddress}
                                labelClassName="content-step-form label-step-form"
                            />
                        </Col>
                    </Row>
                    <Row gutter={[0, 12]}>
                        <Col span={12} className="pr-[12px]">
                            <ItemView
                                label="物件名"
                                value={displayInfo?.name}
                                labelClassName="content-step-form label-step-form"
                            />
                        </Col>
                    </Row>
                </div>

                <div className="w-full mb-[48px]">
                    <span className="content-step-form heading-step-form">売却条件</span>
                    <Divider className="mb-6 my-1" />
                    <Row gutter={[0, 12]} className="mb-6">
                        <Col span={12} className="pr-[12px]">
                            <ItemView
                                label="売却価格"
                                value={commonHelpers.roundTenThousandYen(displayInfo?.bidPrice)}
                                type="number"
                                suffix="万円"
                                labelClassName="content-step-form label-step-form"
                            />
                        </Col>
                        <Col span={12} className="pl-[12px]">
                            <ItemView
                                label="手付金"
                                value={displayInfo?.deposit}
                                type="number"
                                suffix="円"
                                labelClassName="content-step-form label-step-form"
                            />
                        </Col>
                    </Row>
                    <Row gutter={[0, 12]} className="mb-6">
                        <Col span={12} className="pr-[12px]">
                            <ItemView
                                label="手付解除期限"
                                value={displayInfo?.depositReleaseDueDate}
                                dateFormat={DATE_FORMAT.FORMAT1}
                                labelClassName="content-step-form label-step-form"
                            />
                        </Col>
                        <Col span={12} className="pl-[12px]">
                            <ItemView
                                label="融資未承認の場合の解除期限"
                                value={displayInfo?.unapprovedLoanReleaseDueDate}
                                dateFormat={DATE_FORMAT.FORMAT1}
                                labelClassName="content-step-form label-step-form"
                            />
                        </Col>
                    </Row>
                    <Row gutter={[0, 12]} className="mb-6">
                        <Col span={12} className="pr-[12px]">
                            <ItemView
                                label="違約金割合"
                                value={displayInfo?.penaltyRateDisplay}
                                labelClassName="content-step-form label-step-form"
                            />
                        </Col>
                        <Col span={12} className="pl-[12px]">
                            <ItemView
                                label="公租公課の分担起算日"
                                dateFormat={DATE_FORMAT.FORMAT1}
                                value={displayInfo?.shareDate}
                                labelClassName="content-step-form label-step-form"
                            />
                        </Col>
                    </Row>
                    <Row gutter={[0, 12]}>
                        <Col span={12} className="pr-[12px]">
                            <ItemView
                                label="決済・引渡し日"
                                value={
                                    displayInfo?.deliveryDate
                                        ? `売買契約締結後${displayInfo?.deliveryDate}ヶ月以内`
                                        : ''
                                }
                                labelClassName="content-step-form label-step-form"
                            />
                        </Col>
                    </Row>
                </div>

                <div className="w-full">
                    <span className="content-step-form heading-step-form">有効期間</span>
                    <Divider className="my-1 mb-6" />

                    <Row gutter={[0, 12]} className="mb-6">
                        <Col span={12} className="pr-[12px]">
                            <ItemView
                                label="契約有効期間"
                                value={displayInfo?.contractPeriod}
                                type="number"
                                suffix="ヶ月"
                                labelClassName="content-step-form label-step-form"
                            />
                        </Col>
                    </Row>
                </div>

                <div className="w-full">
                    <span className="content-step-form heading-step-form">報酬</span>
                    <Divider className="my-1 mb-6" />

                    <Row gutter={[0, 12]} className="mb-6">
                        <Col span={12} className="pr-[12px]">
                            <ItemView
                                label="報酬金額（仲介手数料）"
                                value={commonHelpers.formatMoney(Number(displayInfo?.brokerageFee))}
                                suffix="円"
                                labelClassName="content-step-form label-step-form"
                            />
                        </Col>
                    </Row>
                    <Row gutter={[0, 12]} className="mb-6">
                        <Col span={12} className="pr-[12px]">
                            <FormCheckBox
                                name="isAgreed"
                                required
                                showErrorMessage={false}
                                options={[
                                    {
                                        value: 1,
                                        label: '内容に同意します。',
                                    },
                                ]}
                                className="mb-0"
                            />
                        </Col>
                    </Row>
                </div>
            </Row>
        </>
    );
};
